// src/context/AiTripContext.js
import React, { createContext, useContext, useState } from "react";

const AiTripContext = createContext();

export function AiTripProvider({ children }) {
    const [aiTrip, setAiTrip] = useState(null);
    const [aiGenerationError, setAiGenerationError] = useState(null);

    const [aiGenerationStatus, setAiGenerationStatus] = useState(null);
    // null | "loading" | "ready"

    const [pendingAiTrip, setPendingAiTrip] = useState(null);

    return (
        <AiTripContext.Provider
            value={{
                aiTrip,
                setAiTrip,
                aiGenerationStatus,
                setAiGenerationStatus,
                pendingAiTrip,
                setPendingAiTrip,
                aiGenerationError,
                setAiGenerationError,
            }}
        >
            {children}
        </AiTripContext.Provider>
    );
}

export function useAiTrip() {
    return useContext(AiTripContext);
}
